{
  "app.title": "Service Software Online (SeSO)",
  "app.titleMobile": "SeSO",
  "label.logout": "Sign out",
  "label.settings": "Settings",
  "label.invertTimeline": "Sort from old (left) to new (right)",
  "label.dateFormat": "Date Format",
  "label.country": "Country",
  "label.city": "City",
  "label.functionalLocation": "Functional Location",
  "label.format": "Format",
  "label.systemSerialNumber": "System serial number {{systemSerialNumber}}",
  "label.system": "System",
  "search.callToAction": "Serial Number, Functional Location or Equipment (Tech) ID",
  "search.callToActionShort": "Serial, Func. Loc. or Equip. (Tech) ID",
  "label.serialNumber": "Serial Number",
  "label.systemMaterialNumber": "Material number",
  "label.loadingOverview": "Loading Overview",
  "message.enterValidSystemNumber": "Please enter a valid system serial number or functional location",
  "message.enterValidTicketNumber": "Please enter a valid ticket number",
  "label.input.systemSerialNumber": "System Serial Number",
  "label.input.ticketNumber": "Provide a Ticket Number (optional)",
  "button.search": "Search",
  "message.enterSystemSerialNumber": "Enter the serial number of the System to check the status of the corresponding system",
  "label.status": "State",
  "label.arcings": "Arcings",
  "label.xraErrors": "XRA Errors",
  "label.date": "Date",
  "label.day": "Day",
  "label.dailyScans": "Daily Scans",
  "label.noDataFound": "System not found",
  "message.noDataFound": "No system related to your requested system serial number or functional location could be found.",
  "label.error": "Error",
  "message.error.internalServerError": "An internal server error has occurred.\n Please contact the",
  "message.recommendation.brokenCable": "According to our calculations the coil performance is limited.<br> There is a higher probability that this is due to a defective cable <br> (cable check only available for Body 18 coil).",
  "message.error.malformedIdentifier": "Malformed identifier. \nSystem Serialnumber must be string and MaterialNumber must be number",
  "message.error.forbiddenPt1": "The same ticket number ",
  "message.error.forbiddenPt2": "has been used more than 4 times for different serial numbers\r\ntherefore the ticket number will be blocked,\r\nplease contact the ",
  "message.error.forbiddenPt3": " for further clarification.",
  "message.error.notLoggedIn": "You are not logged in.",
  "message.error.unauthorized": "Sorry, you don't have access to Service SW Online.",
  "message.error.internalFileShareServerError": "An internal error has occurred on the file share",
  "message.error.systemNotSupported": "System is not supported",
  "message.noFileImageFound": "No image found",
  "label.feedback": "Feedback",
  "label.openIssues": "Open Issues",
  "message.noOpenIssues": "no current open issues",
  "label.noSystemSelected": "no system selected",
  "label.notSupportedTubes": "System is not supported in SeSO",
  "message.error.noSystemSerialNumber": "Search field is empty",
  "message.error.ticketNumberInvalid": "The ticket number is not valid",
  "label.searchForSystem": "Search for a System",
  "label.input.serialNumber": "Functional Location or Serial Number",
  "label.input.modalityId": "Modality",
  "label.input.equipmentStatus": "Equipment Status",
  "label.input.supportStatus": "Support in SeSO",
  "message.isRequired": "* required",
  "supported": "Supported",
  "unsupported": "Limited",
  "label.productName": "Product Name",
  "label.softwareVersion": "Software Version",
  "label.equipmentStatus": "Equipment Status",
  "label.supportStatus": "Support in SeSO",
  "label.customerName": "Customer Name",
  "label.equipmentId": "Equipment ID",
  "label.equipmentTechId": "Equipment Tech ID",
  "searchHistory.recentSystems": "Your recent systems",
  "searchHistory.clear": "Clear recent systems",
  "label.customerLocation": "Country and City",
  "label.selectSystem": "Please choose one",
  "label.foundSeveralSystemsDetails": "Multiple systems found",
  "label.EQ_INSTALL_DT": "Installed Date",
  "label.EQ_EOD_DT": "End of Delivery Date",
  "label.EQ_EOS_DT": "End of Support Date",
  "label.systemInformation": "System Information",
  "label.docBoxPanel": "DocBox Records",
  "label.docBoxPage": "DocBox Records",
  "label.srsConnectivity": "SRS Connectivity",
  "label.SRS_FTP_LAST_RECEIVED_DT_TM": "Last file transfer",
  "label.SRS_LAST_PROACTIVE_DT": "Last event transfer",
  "label.SRS_LAST_REACTIVE_DT": "Last remote login",
  "label.SRS_CONNECTION_LEVEL": "Connectivity Level",
  "label.SRS_CONNECTION_LEVEL.tooltip.connected_not_ruh_ready": "Connected but not ready for Remote Update Handling (see also next field Connectivity Status)",
  "label.SRS_CONNECTION_LEVEL.tooltip.ruh_ready": "Connected and ready for Remote Update Handling",
  "label.SRS_STATUS_TEXT": "Connectivity Status",
  "label.label.SRS_STATUS_TEXT.tooltip.undefined": "Not connected",
  "label.SRS_STATUS_TEXT.tooltip.sd_not_found": "Agent for Software Distribution not installed",
  "label.SRS_STATUS_TEXT.tooltip.ovo_and_sd_not_found": "Agent for HP Openview Event Management and for Software Distribution not installed",
  "label.patternOverview": "PSM Pattern",
  "label.statesForThirtyDays": "Pattern hit indicators are based on the last 30 days.",
  "label.ComponentOverview": "Component overview",
  "label.SolutionOverview": "Solution Overview",
  "label.Modules": "Modules",
  "label.Module": "Module",
  "label.overview": "Overview",
  "label.type": "Type",
  "label.atellicaSolution": "Atellica Solution",
  "label.creationDate": "Creation Time",
  "label.ticketNumber": "Ticket no.",
  "label.description": "Subject",
  "label.Ticketstatus": "Operational State",
  "label.TicketstatusFN": "Operational",
  "label.TicketstatusLN": "Status",
  "label.createdBy": "Creator",
  "label.serviceTickets": "Service Tickets",
  "label.plannedActivities": "Planned Activities",
  "label.nextplannedActivity": "Next Planned Activity",
  "label.lastoverdueActivity": "Latest Overdue Activity",
  "label.plannedActivitiesTitle": "Planned Activities",
  "label.plannedStart": "Planned Start",
  "label.plannedEnd": "Planned End",
  "label.link": "Link",
  "label.typeOfActivity": "Type of Activity",
  "label.subject": "Subject",
  "label.information": "Information",
  "label.show": "Show",
  "label.eventStatus": "Event List shown for",
  "label.noErrorFound": "No Error for selected range",
  "tube.label.plane": "Plane {{plane}}",
  "tube.label.tube": "Tube",
  "tube.label.tubeMaterialNumber": "Tube-Mat-No",
  "tube.label.tubeSerialNumber": "Tube-Ser-No",
  "tube.label.deliveryDay": "Delivery Day",
  "tube.label.currentScanCounter": "Current Scan Counter",
  "tube.label.date": "Date",
  "tube.label.day": "Day",
  "tube.label.status": "State",
  "tube.label.dailyScans": "Daily Scans",
  "tube.tubeInformation": "Tube Information",
  "tube.label.replacementPart": "Replacement Part:",
  "tube.message.disclaimer": "Please be aware that the provided tube severity is based on data from the\n latest data transfer and can have a delay of one day. Only for reactive service.",
  "tube.message.error.unauthorized": "Sorry, you don't have access to Service SW Online.",
  "tube.message.error.forbidden": "The same ticket number has been used more than 4 times for different serial numbers\n therefore the ticket number will be blocked,\n please contact the <a href='mailto:seso.team@siemens-healthineers.com?subject=SeSO%20Tube%20Companion%20reports%20that%20the%20user%20is%20not%20authorized'> SeSO Team</a> for further clarification.",
  "tube.label.noDataFound": "No data found",
  "tube.message.noDataFound": "No data corresponding to your requested System Serial Number could be found.",
  "tube.message.error.internalServerError": "An internal server error has occurred.\n Please contact the<a href='mailto:seso.team@siemens-healthineers.com?subject=SeSO%20Tube%20Companion%20reports%20an%20internal%20server%20error'> SeSO Team</a>",
  "tube.label.notSupportedTubes": "Not supported tubes",
  "text.headlineText": "Number of pattern hits in the past",
  "text.lastRequest": "Last Request:",
  "text.requestMessage": "Request message:",
  "label.noMatchesFound": "No error matches found (but pattern maturity low)",
  "label.coilInformation": "Information for ",
  "label.coilSerialNumber": "Serial No.",
  "label.coilMaterialNumber": "Material No.",
  "label.replacementPart": "Replacement Part",
  "label.channel": "Channel",
  "label.relevantInformation": "Further Information",
  "coil.label.noDataFound": "No data found",
  "coil.message.noDataFound": "No data corresponding to your requested System Serial Number could be found.",
  "label.coilLabel": "Coil Name",
  "label.localCoils": "Local Coils",
  "label.searchBySystemSerialNumber": "Search by System-Serial-Number",
  "message.enterNumericSerialNumber": "Please enter a numeric System Serial Number",
  "message.enterSerialNumber": "Enter the serial number of the MR-System to check the status of the corresponding mrs",
  "label.mrSerialNumber": "MR-Ser-No",
  "label.mrMaterialNumber": "MR-Mat-No",
  "label.lastUpdateHeader": "Last Update",
  "label.lastUpdatePatternHeader": "Last Match",
  "label.lastUpdatePSMHeader": "Pattern Match",
  "label.lastUpdatePXRHeader": "PXR",
  "label.mrTickerLastDataSourceRefresh.statusHeader": "MR XMART Pattern",
  "label.ctPatternLastDataSourceRefresh.statusHeader": "CT Pattern",
  "label.srsDeviceMonitoringLastDataSourceRefresh.statusHeader": "SRS Device Monitoring",
  "label.psmPatternLastDataSourceRefresh.statusHeader": "PSM Alert",
  "label.psmView": "PSM View",
  "solutionProposition.instructionText": "Instructions",
  "emptyState.noErrorPatternHitFound": "No error pattern hit found",
  "emptyState.noErrorMatchesFound": "No error matches found (but pattern maturity low)",
  "label.srsRefreshButton.text": "Request new data",
  "label.srsRefreshButton.collecting": "Request new data",
  "label.lastDataSourceRefresh.warningMessage": "Attention! Data was not loaded within past 24 h.",
  "label.lastDataSourceRefresh.coilHeader": "CS SDTB for Local Coils",
  "label.lastDataSourceRefresh.tubeHeader": "X-ray Tube Data",
  "label.lastDataSourceRefresh.statusMessage": "Attention! Data was not loaded within past 24 h.",
  "label.lastDataSourceRefresh.noInformation": "No information available",
  "label.ComponentStatus": "Component Status",
  "label.autocheck": "AutoCheck Data for past",
  "label.autoCheckDetails": "Autocheck Status",
  "label.maintenance": "Maintenance Data for past",
  "label.maintenanceStatus": "Maintenance Status",
  "label.process": "Event logs for past",
  "label.processDetails": "Event logs",
  "label.column_data": "Select Columns to personalise the table",
  "message.columnData": "Add or remove columns. To change the column order, drag and drop a field.",
  "solutionProposition.instructionsText": "Instructions",
  "label.psm": "PSM Alerts",
  "label.components": "Components",
  "label.lastUpdated": "Last updated",
  "label.listOf": "List of ",
  "label.columnOptions": "Column options",
  "label.addColumn": "Add a column",
  "label.openLogCompanion": "Open Log Companion",
  "label.noDataTube": "No data available for this device in Tube Companion",
  "label.noDataCoil": "No data available for this device in Coil Companion",
  "label.noDataPatternMatch": "No Pattern Matches reported for this component",
  "label.noComponentDataPatternMatch": "No Pattern Matches reported",
  "label.clearAll": "Clear All",
  "label.addRemoveFilter": "Add/Remove Filter",
  "label.search": "Search",
  "label.noMaterialNumber": "Coil material number: not available",
  "label.noPlannedActivity": "No planned activities\n available for this system",
  "label.noOverdueActivity": "No overdue activities\n available for this system",
  "label.noFutureActivity": "No activity planned in \n the future for this system",
  "label.help": "Help",
  "label.whatsNew": "What's New",
  "label.releaseNotes": "Release Notes",
  "label.latestAnnouncement": "Latest Announcement",
  "label.getHelp": "Get Help",
  "label.support": "Support",
  "label.getHelpLink": "SeSO Help on Viva Engage",
  "message.getHelp": "For the latest information and helpful files (e.g. supported coils and tubes) visit our group in Viva Engage.",
  "label.featureList": "Feature List",
  "syngovia.label.noDataFound": "No data found",
  "syngovia.label.viewAll": "View All",
  "syngovia.label.customerOverview": "Overview",
  "syngovia.label.healthcheck": "Healthcheck",
  "syngovia.label.totalHealthcheckScore": "Total of Healthcheck score",
  "syngovia.label.syngovia": "syngo.via",
  "syngovia.label.dicomProxy": "DICOM Proxy",
  "syngovia.label.dicomNodes": "DICOM Nodes",
  "syngovia.label.dicomConnection": "DICOM",
  "syngovia.label.network": "Network",
  "syngovia.label.master": "Master",
  "syngovia.label.search": "Search",
  "syngovia.label.compare": "Compare",
  "syngovia.label.compareDevices": "Compare Devices",
  "syngovia.label.clearAll": "Clear All",
  "syngovia.label.close": "Close",
  "syngovia.label.backgroundMessage": "Compare device configurations",
  "syngovia.label.chooseGroup": "Choose group",
  "syngovia.label.chooseDevice": "Choose device",
  "syngovia.label.edit": "Edit",
  "syngovia.label.virtualized": "Virtualized",
  "syngovia.label.logicalName": "Logical Name",
  "syngovia.label.serialNumber": "Serial Number",
  "syngovia.label.product": "Product",
  "syngovia.label.service": "Service",
  "syngovia.label.hostname": "Hostname",
  "syngovia.label.ip": "IP",
  "syngovia.label.os": "OS",
  "syngovia.label.deviceId": "Device ID",
  "syngovia.label.device": "Device",
  "syngovia.label.deviceString": "Device String",
  "syngovia.label.isPrimary": "Is Primary",
  "syngovia.label.monitorResolution": "Monitor Resolution",
  "syngovia.label.driverVersion": "Driver Version",
  "syngovia.label.driverDate": "Driver Date",
  "syngovia.label.networkSpeed": "Network Speed",
  "syngovia.label.networkAdapter": "Network Adapter",
  "syngovia.label.modelName": "Model Name",
  "syngovia.label.aet": "AET",
  "syngovia.label.port": "Port",
  "syngovia.label.sn": "SN",
  "syngovia.label.handover": "Handover",
  "syngovia.label.msl": "MSL",
  "syngovia.label.swVersion": "SW Version",
  "syngovia.label.dns": "DNS",
  "syngovia.label.subnet": "Subnet",
  "syngovia.label.gateway": "Gateway",
  "syngovia.label.virtual": "Virtual",
  "syngovia.label.iloIp": "ILOIP",
  "syngovia.label.hpSn": "HP SN",
  "syngovia.label.sku": "SKU",
  "syngovia.label.systemModel": "System Model",
  "syngovia.label.identification": "Identification",
  "syngovia.label.storage": "Storage",
  "syngovia.label.name": "Name",
  "syngovia.label.loading": "Loading...",
  "syngovia.label.On": "On ",
  "syngovia.label.last7Days": "Last 7 days",
  "syngovia.label.low": "Low",
  "syngovia.label.medium": "Medium",
  "syngovia.label.high": "High",
  "syngovia.label.category": "Category",
  "syngovia.label.totalScore": "Total Score",
  "syngovia.label.description": "Description",
  "syngovia.label.noDescription": "No additional information is available.",
  "syngovia.label.identifiedAt": "Identified at",
  "syngovia.label.responsible": "Responsible",
  "syngovia.label.issueId": "Issue ID",
  "syngovia.label.skb": "SKB",
  "syngovia.label.score": "Score",
  "syngovia.label.filters": "Filters",
  "syngovia.label.dateRange": "Date Range",
  "syngovia.label.rsc": "RSC",
  "syngovia.label.customer": "Customer",
  "syngovia.label.others": "Others",
  "syngovia.label.unknown": "Unknown",
  "syngovia.label.rangeLow": "Low (0-49 points)",
  "syngovia.label.rangeMedium": "Medium (50-99 points)",
  "syngovia.label.rangeHigh": "High (>100 points)",
  "syngovia.label.noIssuesFoundForThisServer": "No issues found for this server.",
  "syngovia.label.createTicket": "Create ticket",
  "syngovia.label.ticket": "Ticket",
  "syngovia.label.ticket.contract": "Contract",
  "syngovia.label.ticket.creation": "Ticket Creation",
  "syngovia.label.ticket.detail": "Ticket Detail",
  "syngovia.label.ticket.creator": "Ticket Creator",
  "syngovia.label.ticket.dateFound": "Date Found",
  "syngovia.label.ticket.scoreDescription": "Score Description",
  "syngovia.label.ticket.scoreComment": "Score Comment",
  "syngovia.label.ticket.validUntil": "Valid Until",
  "syngovia.label.ticket.hsnode": "HSNODE",
  "syngovia.label.ticket.material": "Material",
  "syngovia.label.ticket.serial": "Serial",
  "syngovia.label.ticket.version": "Version",
  "syngovia.label.ticket.creating": "Creating ticket",
  "syngovia.label.ticket.created": "Ticket created",
  "syngovia.label.ticket.shortCreated": "Created",
  "syngovia.label.ticket.errorCreating": "Error creating ticket",
  "dnasyngovia.label.responsible": "Responsible",
  "dnasyngovia.label.scoreSeverity": "Score Serverity",
  "syngovia.message.dataNotFound": "Data not found!",
  "syngovia.message.dataNotFoundDetailed": "SeSO couldn't find any data related to this system.",
  "syngovia.message.noDataFound": "No data corresponding to your requested System Serial Number could be found.",
  "syngovia.message.disclaimer.portalTitle": "Application under construction",
  "syngovia.message.disclaimer.portalMessage": "<strong>Welcome to D&A <em>syngo</em>.via new feature!</strong> Our team is constantly working to improve your experience. Thanks for your patience and support as we grow.",
  "syngovia.message.disclaimer.portalConfirm": "Go to syngo.via",
  "syngovia.message.disclaimer.mobileTitle": "Mobile view not supported",
  "syngovia.message.disclaimer.mobileMessage": "<strong>This initial D&A <em>syngo</em>.via version is not optimized for mobile devices.</strong> For a better experience, please, access the desktop version.",
  "syngovia.message.disclaimer.mobileConfirm": "Ok, I understand",
  "label.copyToClipboard": "Copy System status to clipboard",
  "message.systemInfo": "This action might take several seconds.",
  "label.copyToClipboardFailed": "Copy failed",
  "message.copyToClipboardFailed": "Please try again later.",
  "label.copyToClipboardSucceed": "System status copied",
  "message.copyToClipboardSucceed": "Status was copied to your clipboard.",
  "label.copyToClipboardProgressHeader": "Copying",
  "label.copyToClipboard.tooltip": "Copy the current SeSO system status to clipboard",
  "label.sendSystemInfoEmail": "Prepare system status by email",
  "label.sendSystemInfoEmailFailed": "Email preparation failed",
  "message.sendSystemInfoEmailFailed": "Please try again later.",
  "label.sendSystemInfoEmailSucceed": "System status by email prepared",
  "message.sendSystemInfoEmailSucceed": "System status was prepared to be sent by email",
  "label.sendSystemInfoEmailProgressHeader": "Preparing",
  "label.openSystemInfoEmailTo.tooltip": "Receive the current SeSO system status by email",
  "label.refreshPanel.tooltip": "Last Panel Refresh\n",
  "label.privacyNotice": "Privacy Notice",
  "label.advancedSearch": "Advanced Search",
  "label.advanceSearchResultInfoIcon.tooltip":"Maximum display of 500 systems reached - please refine your search.",
  "message.refineAdvancedSearch": "Maximum display reached - please refine your search.",
  "message.startAdvancedSearch": "Start using filters \n to see the first results.",
  "message.noSystemInAdvanceSearch": "<strong>No systems found</strong>\nPlease refine your search.",
  "label.sevenDays": "7 Days Overview",
  "label.patternMatches": "Pattern Matches",
  "label.startingWith": "(starting with...)",
  "label.exactMatch": "(exact match)",
  "label.containing": "(containing...)",
  "label.advancedSearchInfoIcon.tooltip": "Results for <strong>(containing...) search fields</strong> include matches anywhere in the text (min. 3 characters).<br><br>Results for <strong>(exact match) search fields</strong> must match the full entered text exactly.<br><br>Results for <strong>(starting with...) search fields</strong> start with the entered text (min. 3 characters).",
  "label.magnetPressure": "Helium & Pressure & Temperature",
  "label.termsOfUse": "Terms of Use",
  "label.termsOfUseChinese": "Terms of Use for users in China",
  "mrqLabel.mrqReport": "MRQ Report",
  "mrqLabel.PatternMatches": "Pattern Matches",
  "cooling": {
    "dataHeader": "Cooling Data",
    "localSystemTimezone": "Local System Timezone",
    "graph": {
      "addCustomGraph": "Add Custom Graph",
      "customGraphTitle": "Custom Graph",
      "dataLabel": "Data",
      "createGraph": "Add Graph",
      "cancel": "Cancel",
      "delete": "Delete",
      "loadingError": "Error loading cooling graph data",
      "noDataForSelectedDates": "No data available for selected dates."
    }
  },
  "atNeocorApplications": {
    "label.logs": "Looking for Logs?",
    "message.logs": "Here’s a direct link to the Log Companion:",
    "label.logsButton": "Check Logs",
    "label.sonar": "Looking for Monitoring Data?",
    "message.sonar": "Here’s a direct link to Sonar:",
    "label.sonarButton": "Check Dashboard"
  },
  "inactive_system_text": "Inactive",
  "spareParts.allServiceTickets": "All Service Tickets",
  "spareParts.allServiceParts": "All Service Parts",
  "spareParts.serviceTickets": "Service Tickets",
  "spareParts.serviceParts": "Service Parts",
  "spareParts.created": "Created",
  "spareParts.ticketNumber": "Ticket Number",
  "spareParts.subject": "Subject",
  "spareParts.operationalState": "Operational State",
  "spareParts.partStatus": "Part Status",
  "spareParts.ariaLabel.copyClipboard": "Copy results to clipboard",
  "spareParts.loadingTickets": "loading tickets...",
  "spareParts.dateRange": "Date Range",
  "spareParts.search": "Search",
  "spareParts.filter": "Filter",
  "spareParts.clearAll": "Clear All",
  "spareParts.cancel": "Cancel",
  "spareParts.apply": "Apply",
  "spareParts.partDescription": "Part Description",
  "spareParts.partNumber": "Part Number",
  "spareParts.partNumberShort": "Part No.",
  "spareParts.consumedDate": "Consumed date",
  "spareParts.ticketStatus": "Ticket Status",
  "spareParts.ticketType": "Ticket Type",
  "spareParts.quantity": "Quantity",
  "spareParts.quantityShort": "Quant.",
  "spareparts.highestConsumed": "Highest Consumed Part",
  "spareparts.mostConsumedFrequency": "Changed {{units}}x in 2 years",
  "spareparts.partsConsumed": "Parts Consumed",
  "spareparts.partsOrdered": "Parts Ordered",
  "spareparts.mostReplacedPart": "Most Replaced Part",
  "spareparts.time": "time",
  "spareparts.times": "times",
  "spareParts.emptyState.serviceTicket": "Access Service Tickets and expand range.",
  "spareParts.emptyState.servicePart": "Access Service Parts and expand range.",
  "spareParts.emptyState.noDataAvailable": "No data available",
  "spareParts.emptyState.noDataMatches": "No data matches the period selected",
  "spareParts.emptyState.noDataAvailableDevice": "No data available for this device",
  "spareParts.emptyState.expandTimeRange": "Please expand time range.",
  "spareParts.emptyState.noResults": "No results found",
  "spareParts.emptyState.refineSearch": "Please refine your search.",
  "spareParts.emptyState.noDataPastYear": "No data available for the past year",
  "spareParts.emptyState.noRecordsDevice": "No record found for this device.",
  "spareParts.emptyState.noTicketsDevice": "No tickets found for this device.",
  "spareParts.emptyState.expandTimeTickets": "Expand time range to view older tickets.",
  "spareParts.emptyState.expandTimeRecords": "Expand time range to view older records.",
  "spareParts.emptyState.ticket": "No data available for this device.",
  "spareParts.emptyState.parts": "No replacement order placed.",
  "spareParts.HighestConsumed.title": "Highest Consumed Parts",
  "spareParts.AmountConsumed.title":"Amount Consumed",
  "spareParts.subtitle.last12Months":"Last 12 months",
  "spareParts.AmountConsumed.xAxisName":"Month",
  "spareParts.AmountConsumed.yAxisName":"Quantity",
  "spareParts.AmountConsumed.months":[
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
  ],
  "spareParts.emptyState.noDataAvailabe": "No data available.",
  "cts.gantry.init": "Gantry_Init",
  "cts.gantry.details": "Details",
  "cts.gantry.updatedOn": "Updated on",
  "cts.gantry.eventAnalysis": "Event Analysis",
  "cts.gantry.logs": "Logs",
  "cts.gantry.compare": "Compare",
  "cts.gantry.tab.allEvents": "All Events",
  "cts.gantry.tab.errors": "Errors",
  "cts.gantry.functionalUnits": "Functional Units",
  "cts.gantry.grid.legend.notExecuted": "Not executed",
  "cts.gantry.grid.legend.executed": "Executed",
  "cts.gantry.grid.legend.failed": "Failed",
  "cts.gantry.grid.legend.successful": "Successful",
  "cts.gantry.search": "Search",
  "cts.gantry.errors": "Errors",
  "cts.gantry.successes": "Successes",
  "cts.gantry.warnings": "Warnings",
  "cts.gantry.informations": "Informations",
  "cts.gantry.allLogs": "All Logs",
  "cts.gantry.table.dateTime": "Date/Time",
  "cts.gantry.table.domainId": "Domain/ID",
  "cts.gantry.table.message": "Message",
  "cts.gantry.table.severity": "Severity",
  "cts.gantry.version": "Version",
  "cts.gantry.unitStatus": "Unit Status:",
  "cts.gantry.lastUpdate": "Last Update:",
  "cts.gantry.onlyErrors": "Only Errors",
  "cts.gantry.loading": "loading..",
  "cts.gantry.noEventsFailed": "No events failed.",
  "cts.gantry.logsNotFound": "Logs not found.",
  "cts.gantry.noErrorsDetected": "No errors detected.",
  "cts.gantry.na": "N/A",
  "cts.gantry.disclaimer.MobileViewMessage": "<strong>This initial Gantry_Init version is not optimized for mobile devices.</strong> For a better experience, please, access the desktop version.",
  "cts.gantry.disclaimer.MobileTitle": "Mobile view not supported",
  "cts.gantry.disclaimer.mobileConfirm": "Ok, I understand",
  "cts.gantry.NoDataAvailable": "No data available",
  "cts.gantry.NoMoreEvents": "No more events",
  "cts.gantry.CTStatus": "CT Status",
  "cts.gantry.informativeSom5som7": "No support to CT Som5 and Som7",
  "cts.gantry.informativeNoSoftwareFamily": "No software family detected. Please contact SeSO Support.",
  "cts.gantry.closeLogs": "Close Logs",
  "cts.gantry.usersLocalTime": "User's local time",
  "cts.gantry.timezone": "Timezone",
  "cts.gantry.deviceLocalTime": "Device Local Time",
  "cts.gantry.otherTimeZones": "Other Timezones",
  "cts.gantry.localOffset": "Local Offset",
  "limitedSupportDisclaimer.message": "This product is only with limited support. We cannot guarantee the correct working of Useful Application links, the Service Ticket area or any other kind of displayed information."
}